import clsx from "clsx";
import React from "react";

interface ITourimsBenefits {
  svg: string;
  title: string;
  description: string;
}

const TourismBenefits: React.FC = () => {
  const tourismBenefitsData: ITourimsBenefits[] = [
    {
      svg: "/tourism/benefits/city.svg",
      title: "Any Tourist City Of The World",
      description:
        "A gateway to unforgettable experiences and cultural wonders.",
    },
    {
      svg: "/tourism/benefits/tourism-board.svg",
      title: "Tourism Boards",
      description: "Boost tourist engagement at city and state levels.",
    },
    {
      svg: "/tourism/benefits/museum-curators.svg",
      title: "Museum Curators",
      description: "Enhance visitor experience with detailed exhibits.",
    },
    {
      svg: "/tourism/benefits/historical-sites.svg",
      title: "Historical Sites",
      description: "Preserve and share cultural heritage with modern tools.",
    },
    {
      svg: "/tourism/benefits/pilgrimage-centers.svg",
      title: "Pilgrimage Centers",
      description: "Offer spiritual narratives to devotees.",
    },
    {
      svg: "/tourism/benefits/corridor.svg",
      title: "Tourism Corridors",
      description: "Seamlessly connecting heritage, culture, and experiences.",
    },
  ];

  return (
    <div>
      <div className="flex flex-col text-[#182152] justify-center items-center text-3xl sm:text-4xl lg:text-5xl xl:text-6xl text-center lg:gap-2 xl:gap-3 ">
        <h3>Who can benefit from this</h3>
        <h3>Tourism Technology Solution?</h3>
      </div>
      <div className="pt-5 lg:pt-10 xl:pt-16 grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-5 xl:gap-10">
        {tourismBenefitsData.map((data, index) => {
          return (
            <div
              className={clsx("xl:h-96 flex ", {
                "xl:items-end": index % 2 !== 0,
              })}
              key={data.title}
            >
              <div className="flex shadow  flex-col h-fit rounded-lg p-5 lg:px-7">
                <div className="flex justify-start">
                  <img
                    src={data.svg}
                    alt=""
                    className="w-10 h-10 lg:w-12 lg:h-12"
                  />
                </div>
                <h5 className="font-medium items-center text-xl pt-3 lg:text-2xl">
                  {data.title}
                </h5>
                <p className="pt-2">{data.description}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TourismBenefits;
